/* eslint-disable */

import blending from '../shaderlib/blending.glsl.js'

export default (count, blendMode) => `
// -----------------------------------------------------------------------------
//
// Composites ${count} sampler2Ds using the ${blendMode} blending mode.
//
// This shader is dynamically generated for each update to the number of
// samplers and the blending mode.
//
// -----------------------------------------------------------------------------

uniform sampler2D uTextures[${count}];

varying vec2 vUv;

${blending}

void main() {
    vec3 color = vec3(0.0);

    ${blendLoop(count, blendMode)}

    gl_FragColor = vec4(color, 1.0);
}
`

/**
 * Resolves to a series of blend operations using.
 * @param {Number} count - The number of textures to blend
 * @param {String} blendMode - The blend mode to use
 */
function blendLoop(count, blendMode) {
    return Array(count).fill(0).map((_, i) => {
        return `color = blend${blendMode}(color, texture(uTextures[${i}], vUv).rgb);`
    }).join('\n\r    ')
}
